"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const capitalizeEveryWord = str => str.replace(/\w\S*/g, w => w.replace(/^\w/, c => c.toUpperCase()).replace(/\B[A-Z]/g, c => c.toLowerCase()));
var _default = exports.default = capitalizeEveryWord;